import { Message } from 'element-ui'
import { getDriverLogoffStatus } from '@/api/drivers'
// 司机相关静态文件

// 图片驳回原因
export const driver_img_reject_reason = {
  // 身份证正面
  identity_card_front: [
    {label: "身份证正面照片未实景拍摄，请拍摄身份证原件", value: "身份证正面照片未实景拍摄，请拍摄身份证原件"},
    {label: "身份证正面不清晰（须无遮挡，无反光）", value: "身份证正面不清晰（须无遮挡，无反光）"},
    {label: "身份证正面有修改痕迹", value: "身份证正面有修改痕迹"},
    {label: "手动输入", value: 1},
  ],
  // 身份证反面
  identity_card_reverse_side: [
    {label: "身份证反面照片未实景拍摄，请拍摄身份证原件", value: "身份证反面照片未实景拍摄，请拍摄身份证原件"},
    {label: "身份证反面不清晰（须无遮挡，无反光）", value: "身份证反面不清晰（须无遮挡，无反光）"},
    {label: "身份证反面有修改痕迹", value: "身份证反面有修改痕迹"},
    {label: "手动输入", value: 1},
  ],
  // 驾驶证
  driving_licence: [
    {label: "驾驶证照片未实景拍摄，请拍摄驾驶证原件", value: "驾驶证照片未实景拍摄，请拍摄驾驶证原件"},
    {label: "驾驶证照片不清晰（须无遮挡，无反光）", value: "驾驶证照片不清晰（须无遮挡，无反光）"},
    {label: "驾驶证信息有修改痕迹", value: "驾驶证信息有修改痕迹"},
    {label: "手动输入", value: 1},
  ],
  //车辆照片右后方45°
  car_right_rear: [
    {label: "车辆右后方45°需实景拍摄，请正确拍摄车辆照片", value: "车辆右后方45°需实景拍摄，请正确拍摄车辆照片"},
    {
      label: "车辆右后方45°拍摄角度不正确，车牌号和车辆整体须清晰可见",
      value: "车辆右后方45°拍摄角度不正确，车牌号和车辆整体须清晰可见"
    },
    {label: "车辆右后方45°不清晰，车牌号和车辆整体须清晰可见", value: "车辆右后方45°不清晰，车牌号和车辆整体须清晰可见"},
    {label: "暂不接受出租车加盟", value: "暂不接受出租车加盟"},
    {label: "车辆信息有修改痕迹", value: "车辆信息有修改痕迹"},
    {label: "车辆信息与行驶证信息不符（车牌号不一致）", value: "车辆信息与行驶证信息不符（车牌号不一致）"},
    {label: "车辆外观不洁净", value: "车辆外观不洁净"},
    {label: "车身含有实习标志", value: "车身含有实习标志"},
    {label: "车身有明显广告标识", value: "车身有明显广告标识"},
    {label: "手动输入", value: 1},
  ],
  //车辆左前方
  car_left_front: [
    {label: "车头左前方45°需实景拍摄，请正确拍摄车辆照片", value: "车头左前方45°需实景拍摄，请正确拍摄车辆照片"},
    {
      label: "车头左前方45°拍摄角度不正确，车牌号和车辆整体须清晰可见",
      value: "车头左前方45°拍摄角度不正确，车牌号和车辆整体须清晰可见"
    },
    {label: "车头左前方45°不清晰，车牌号和车辆整体须清晰可见", value: "车头左前方45°不清晰，车牌号和车辆整体须清晰可见"},
    {label: "暂不接受出租车加盟", value: "暂不接受出租车加盟"},
    {label: "车辆信息有修改痕迹", value: "车辆信息有修改痕迹"},
    {label: "车辆信息与行驶证信息不符（车牌号不一致）", value: "车辆信息与行驶证信息不符（车牌号不一致）"},
    {label: "手动输入", value: 1},
  ],
  // 验车视频
  car_inspect_video: [
    {label: "验车视频需实景拍摄，请正确拍摄验车视频", value: "验车视频需实景拍摄，请正确拍摄验车视频"},
    {label: "视频模糊无法识别车身信息，请确保在光线充足的环境拍摄", value: "视频模糊无法识别车身信息，请确保在光线充足的环境拍摄"},
    {label: "车牌号或车型信息有遮挡，请确保车牌号与车型信息清晰可见", value: "车牌号或车型信息有遮挡，请确保车牌号与车型信息清晰可见"},
    {label: "验车视频与车辆图片信息不符，请重新核对后上传", value: "验车视频与车辆图片信息不符，请重新核对后上传"},
    {label: "手动输入", value: 1},
  ],
  //行驶证正本
  car_licence_front: [
    {label: "行驶证正本照片未实景拍摄，请拍摄行驶证原件", value: "行驶证正本照片未实景拍摄，请拍摄行驶证原件"},
    {label: "行驶证正本照片不清晰（须无遮挡，无反光）", value: "行驶证正本照片不清晰（须无遮挡，无反光）"},
    {label: "车辆品牌暂不符合平台加盟标准", value: "车辆品牌暂不符合平台加盟标准"},
    {label: "行驶证信息与车辆信息不符（车牌号不一致）", value: "行驶证信息与车辆信息不符（车牌号不一致）"},
    {label: "行驶证正本有修改痕迹", value: "行驶证正本有修改痕迹"},
    {label: "手动输入", value: 1},
  ],
  //行驶证副本
  car_licence_reverse_side: [
    {label: "行驶证副本照片未实景拍摄，请拍摄证件原件", value: "行驶证副本照片未实景拍摄，请拍摄证件原件"},
    {label: "行驶证副本照片不清晰（须无遮挡，无反光）", value: "行驶证副本照片不清晰（须无遮挡，无反光）"},
    {label: "行驶证信息与车辆信息不符（车牌号不一致）", value: "行驶证信息与车辆信息不符（车牌号不一致）"},
    {label: "须上传行驶证副本页（非检车页）", value: "须上传行驶证副本页（非检车页）"},
    {label: "行驶证副本有修改痕迹", value: "行驶证副本有修改痕迹"},
    {label: "手动输入", value: 1},
  ]
}

// 车辆相关静态信息
export const car_message = {
  // 车辆使用性质信息
  car_character: [
    {label: "非营运", value: 1},
    {label: "租赁", value: 3},
    {label: "预约出租客运", value: 5},
    {label: "出租客运", value: 7},
    {label: "营转非", value: 9},
    {label: "旅游客运", value: 11},
    {label: "预约出租转非", value: 13},
    {label: "公路客运", value: 15},
    {label: "出租转非", value: 17},
  ],
  // 车辆颜色
  car_color: [
    {label: "黑色", value: 1},
    {label: "白色", value: 2},
    {label: "蓝色", value: 3},
    {label: "金色", value: 4},
    {label: "银色", value: 5},
    {label: "棕色", value: 6},
    {label: "灰色", value: 7},
    {label: "黄色", value: 8},
    {label: "粉色", value: 9},
    {label: "红色", value: 10},
    {label: "紫色", value: 11},
    {label: "绿色", value: 12},
    {label: "橙色", value: 13},
  ],
  // 车牌颜色
  plate_number_color: [
    {label: "蓝色", value: 1},
    {label: "绿色", value: 5},
  ],
  // 燃料类型
  fuel_type: [
    {label: "未知", value: 0},
    {label: "汽油", value: 1},
    {label: "电动", value: 2},
    {label: "柴油", value: 3},
    {label: "插电式混合动力", value: 4},
    {label: "混合动力", value: 5},
    {label: "天然气", value: 6},
    {label: "两用燃料", value: 7},
    {label: "燃料电池", value: 8},
    {label: "其他", value: 9},
  ]
}

// 司机相关状态
export const driver_status = {
  // 车辆审核状态
  car_audit_status: [
    {value: 1, label: "待审核"},
    {value: 3, label: "审核未通过"},
    {value: 5, label: "待审核"},
    {value: 7, label: "终审通过"},
    {value: 8, label: "审核未通过"},
  ],
  // 三方验真状态
  three_audit_status: [
    {value: 1, label: "通过"},
    {value: 2, label: "待验证"},
    {value: 3, label: "未通过"},
  ],
  // 司机加盟类型
  join_type: [
    {value: 1, label: "有车加盟"},
    {value: 2, label: "无车加盟"},
  ],
  // 司机上下线
  lock_status: [
    {value: 1, label: "上线"},
    {value: 3, label: "下线"},
    {value: 5, label: "静默"},
    {value: 7, label: "临时下线司机"},
  ]
}

// OCR相关
export const ocr_pic_identify = {
  ocr_fuel_type: (str) => {
    if (typeof str != 'string') {
      return null
    }
    const fuel_type = car_message.fuel_type
    const obj = fuel_type.find(v => str.includes(v.label))
    return obj?.value ?? null
  },
}

/**
 * @description: 根据司机ID查询司机状态（是否已注销）
 * @param {*} driver_id 司机ID
 * @return {*}
 */
export const driverIsLogoff = (driver_id) => {
  return new Promise(async (resolve) => {
    const params = {
      driver_id,
    }
    const { data } = await getDriverLogoffStatus(params)
    if (data?.driver_logoff) { // true 注销。false 未注销
      Message.error('该司机已注销，无法查看司机信息')
    }
    resolve(data?.driver_logoff)
  })
}
